import React, { FC, Dispatch, SetStateAction, useState, useEffect } from "react"
import {
  CalendarDaysIcon,
  ChartBarIcon,
  UserIcon,
  CircleStackIcon,
} from "@heroicons/react/24/outline"
import { Search, Stats } from "@/lib/types"
import { SearchPopup } from "./SearchPopup"

type Props = {
  defaultVal: Stats
  setStat: Dispatch<SetStateAction<Stats>>
}

export const Filters: FC<Props> = (props) => {
  const [salesRepId, setSalesRepId] = useState("")
  const [customerID, setCustomerID] = useState("")

  return (
    <>
      <div className="dark:bg-primary-1 bg-white dark:border-2 shadow-md dark:border-secondary-11 rounded-lg px-4 py-6 lg:block flex justify-between md:flex-nowrap flex-wrap gap-3 lg:mb-0 mb-6">
        <div>
          <div className="flex items-center gap-x-2">
            <CalendarDaysIcon className="2xl:w-5 2xl:h-5 w-4 h-4 dark:text-primary-12 text-light-1" />
            <h1 className="2xl:text-lg text-base dark:text-primary-10 text-light-2">
              Date Range
            </h1>
          </div>
          <div className="flex justify-start pl-5">
            <select
              onChange={(e) =>
                props.setStat((prevStats) => ({
                  ...prevStats,
                  dateRange: e.target.value,
                }))
              }
              className="bg-transparent outline-none dark:text-primary-11 text-light-1 text-sm pt-1 w-auto"
            >
              <option className="dark:bg-primary-1" value="All Time">
                All Time
              </option>
              <option className="dark:bg-primary-1" value="1 Day Ago">
                1 Day Ago
              </option>
              <option className="dark:bg-primary-1" value="1 Week Ago">
                1 Week Ago
              </option>
              <option className="dark:bg-primary-1" value="1 Month Ago">
                1 Month Ago
              </option>
              <option className="dark:bg-primary-1" value="6 Months Ago">
                6 Months Ago
              </option>
              <option className="dark:bg-primary-1" value="1 Year Ago">
                1 Year Ago
              </option>
            </select>
          </div>
        </div>

        <SearchPopup
          title="Sales Rep"
          role="SALESREP"
          icon={ChartBarIcon}
          salesRepId=""
          setStat={props.setStat}
          slug={"salesRepID"}
          setId={setSalesRepId}
        />
        <SearchPopup
          title="Customer"
          role="CUSTOMER"
          icon={UserIcon}
          salesRepId={salesRepId}
          setStat={props.setStat}
          slug={"customerID"}
          setId={setCustomerID}
        />
        <div className="lg:pt-6">
          <div className="flex items-center gap-x-2">
            <CircleStackIcon className="2xl:w-5 2xl:h-5 w-4 h-4 dark:text-primary-12 text-yellow-700" />
            <h1 className="2xl:text-lg text-base dark:text-primary-10 text-light-2">Equipment</h1>
          </div>
          <div className="flex justify-start pl-5">
            <select
              onChange={(e) => {
                props.setStat((prevStats) => ({
                  ...prevStats,
                  equipmentType: e.target.value,
                }))
              }}
              className="bg-transparent outline-none dark:text-primary-11 text-light-1 text-sm pt-1 w-auto"
            >
              <option className="dark:bg-primary-1" value="ANY">
                Any Time
              </option>
              <option className="dark:bg-primary-1" value="DRY_VAN">
                Dry Van
              </option>
              <option className="dark:bg-primary-1" value="SPRINTER_VAN">
                Sprinter Van
              </option>
              <option className="dark:bg-primary-1" value="STRAIGHT_TRUCK">
                Straight Truck
              </option>
              <option className="dark:bg-primary-1" value="FLATBED">
                Flatbed
              </option>
              <option className="dark:bg-primary-1" value="REEFER">
                Reefer
              </option>
            </select>
          </div>
        </div>
      </div>
    </>
  )
}
